<request-payment-record-modal-tag>

    <div
            class="modal js-modal"
            is="modal-base"
            is-open="{ props.isOpen }"
            on-before-show="{ onBeforeShow }"
    >
        <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
        <div class="modal__content">
            <div class="modal__content_inner" >
                <h3 class="modal_heading margin-spacing-3_bottom">支払調書の郵送依頼</h3>
                <p class="note">
                    「郵送依頼をする」ボタンを押すことで、支払調書の郵送をクライアント様に依頼出来ます。
                </p>
                <p class="note">
                    支払調書を郵送してもらえるよう、クライアント様に依頼を送りますか？
                </p>

                <div class="text margin-spacing-3_top">
                    <ul>
                        <li>
                            <span style="font-weight: bold">依頼先クライアント名：</span>
                            <span>{props.client_name}</span>
                        </li>
                    </ul>

                </div>


                <h3 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">
                    依頼に際し、クライアント様にメッセージがある場合は以下にご記入下さい
                </h3>
                <div>
                    <input type="text"
                           name="request_message"
                           class="text_input margin-spacing-1_bottom"
                           value="{state.request_message}"
                           onkeyup={setRequestMessage}
                    >
                </div>

                <div class="wrap_button margin-spacing-4_top">
                    <div class="button button-secondary-large button-border margin-spacing-1_right"
                         type="button"
                         onclick="{ props.onClose }"
                    >
                        閉じる
                    </div>
                    <div
                            class="button button-secondary-large"
                            type="button"
                            value="郵送依頼をする"
                            onclick="{ request }"
                    >
                        郵送依頼をする
                    </div>
                </div>

                <!--/.modal__content_inner-->




                <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
            </div>
            <!--modal__content-->
        </div>
        <!--modal-->
        <script>
            import di from "dependeny-injection";
            import base from "../../modal-base.riot";

            export default {
                api : null,
                components: {
                    "modal-base": base,
                },
                state:{
                    request_message:""
                },
                onBeforeMount(props, state){
                    this.api = di.createApi('project');

                },
                onBeforeShow() {
                    //表示前に入力エリアを初期化
                    this.update({request_message:"よろしくお願い申し上げます"});
                },
                setRequestMessage(e){
                    this.state.request_message = e.target.value;
                },
                async request(e){

                    try{
                        const res = await this.api.request(
                            "payment-record-request",
                            "request",
                            {
                                target_year : this.props.target_year,
                                client_id : this.props.client_id,
                                request_message : this.state.request_message
                            }
                        );
                        alert("郵送依頼を送信しました");
                    }
                    catch (e){
                        alert(e.message);
                    }

                    this.props.onMailRequest();

                }
            };
        </script>

</request-payment-record-modal-tag>
